module.exports = __webpack_public_path__ + "static/img/img_download.16c38ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/regionTutorialIos/img_download.png
// module id = 1105
// module chunks = 1